import { Button, EllipsisSpan, Table } from '@maxtropy/components';
import { useRequest } from 'ahooks';
import { apiV2EnergyUnitSubordinateCostRankPost } from '@maxtropy/device-customer-apis-v2';

import { SubordinateCostProps } from '../SubordinateCost';
import { useContext, useMemo } from 'react';
import { EnergyUsageCostContext } from '../..';
import styles from './index.module.scss';
import { isEmpty, isNil } from 'lodash-es';

const baseColumns = [
  {
    title: '用能单元',
    dataIndex: 'unitName',
    key: 'unitName',
    render: (text: string) => <EllipsisSpan value={text} />,
  },
  {
    title: '用能成本（元）',
    dataIndex: 'cost',
    key: 'cost',
    render: (text: string) => <EllipsisSpan value={text} />,
  },
  {
    title: '占比',
    dataIndex: 'proportion',
    key: 'proportion',
    render: (text: string) => <EllipsisSpan value={`${text ? text + '%' : '--'}`} />,
  },
];

const SubordinateCostRank = ({
  timeResolution,
  time,
  energyMediumId,
  energyUnitGroupId,
  energyUnitId,
}: SubordinateCostProps) => {
  const { setUnitId, setShowDetail } = useContext(EnergyUsageCostContext);

  const { data, loading } = useRequest(
    () =>
      apiV2EnergyUnitSubordinateCostRankPost({
        fromTime: time![0]!.valueOf(),
        toTime: time![1]!.valueOf(),
        timeResolution,
        energyUnitId,
        energyUnitGroupId,
        energyMediumId: energyMediumId === 'total' ? undefined : energyMediumId,
      }).then(res => res.tableList ?? []),
    {
      refreshDeps: [timeResolution, time, energyUnitId, energyUnitGroupId, energyMediumId],
      ready: !!timeResolution && !!time && !!energyMediumId && !!energyUnitId && !!energyUnitGroupId,
    }
  );

  const columns = useMemo(
    () => [
      {
        title: '排名',
        dataIndex: 'rank',
        key: 'rank',
        render: (text: any, record: any, index: number) => {
          return (
            !record.isSummary &&
            !record.isBase && <div className={`${styles.rank} ${styles[`rank_${index + 1}`]}`}>{index + 1}</div>
          );
        },
      },
      ...baseColumns,
      {
        title: '操作',
        dataIndex: 'operation',
        key: 'operation',
        render: (text: any, record: any) => {
          return (
            !record.isSummary &&
            !record.isBase && (
              <Button
                type="link"
                onClick={() => {
                  setShowDetail?.(true);

                  setUnitId?.(record.unitId);
                }}
              >
                详情
              </Button>
            )
          );
        },
      },
    ],
    [data]
  );

  return (
    <Table
      columns={columns}
      dataSource={data}
      rowKey="unitId"
      loading={loading}
      rowClassName={(record, index) => {
        return record.isSummary || record.isBase ? styles.summaryRow : '';
      }}
    />
  );
};

export default SubordinateCostRank;
